module.exports = __webpack_public_path__ + "img/cashier-ad-06.f92767a2.png";